import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";

// project import
import Search from "./Search";
import Message from "./Message";
import Profile from "./Profile";
// import Notification from "./Notification";
import FullScreen from "./FullScreen";
import MobileSection from "./MobileSection";

import useConfig from "hooks/useConfig";
import { MenuOrientation } from "config";
import DrawerHeader from "layout/Dashboard/Drawer/DrawerHeader";
import Notification from "layout/Dashboard/Header/HeaderContent/Notification";

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { menuOrientation } = useConfig();

  const downLG = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}
      {/* {!downLG && <Search />}
      {downLG && <Box sx={{ width: "100%", ml: 1 }} />} */}

      <Notification />
      {/* <Message />
      {!downLG && <FullScreen />}
      {!downLG && <Profile />}
      {downLG && <MobileSection />} */}
    </>
  );
}
